/**
 * Banner global de errores HTTP no fatales (p. ej. 403 Forbidden).
 * Los consumidores (shell) leen `message` y pueden descartar con `clear()`.
 */
import { Injectable, signal } from '@angular/core';

export interface ErrorBannerState {
  titulo: string;
  detalle: string;
}

const AUTO_CLEAR_MS = 6000;

@Injectable({ providedIn: 'root' })
export class ErrorBannerService {
  private readonly state = signal<ErrorBannerState | null>(null);
  private clearTimerId: ReturnType<typeof setTimeout> | null = null;

  /** Estado actual del banner (solo lectura). */
  readonly message = this.state.asReadonly();

  /**
   * Publica un mensaje de error visible en el shell.
   *
   * @param detalle Texto orientado al usuario.
   * @param titulo Título corto (default: acceso denegado).
   */
  show(detalle: string, titulo = 'Acceso denegado'): void {
    this.clearTimer();
    this.state.set({ titulo, detalle });
    this.clearTimerId = setTimeout(() => this.clear(), AUTO_CLEAR_MS);
  }

  /** Oculta el banner activo. */
  clear(): void {
    this.clearTimer();
    this.state.set(null);
  }

  private clearTimer(): void {
    if (this.clearTimerId !== null) {
      clearTimeout(this.clearTimerId);
      this.clearTimerId = null;
    }
  }
}
